module.exports = __webpack_public_path__ + "media/6.3fd03ed1.mp3";